<template>
  <PrivacySection title="4. Come Eliminare i Tuoi Dati">
    <PrivacySubsection title="4.1 Eliminazione Dati Locali (App Mobile)">
      <p>Puoi eliminare i dati memorizzati sul tuo dispositivo in due modi:</p>
      <PrivacyBox>
        <p><strong>Opzione A - Dalle impostazioni dell'app:</strong></p>
        <ol>
          <li>Apri l'applicazione <strong>App degli Scontrini</strong></li>
          <li>Vai su <strong>Impostazioni</strong></li>
          <li>Seleziona <strong>Cancella dati</strong> o <strong>Elimina dati locali</strong></li>
          <li>Conferma l'operazione</li>
        </ol>
        <p><strong>Opzione B - Disinstallazione:</strong></p>
        <p>
          Disinstalla l'applicazione dal tuo dispositivo. Questa operazione elimina
          automaticamente tutti i dati memorizzati localmente dall'app.
        </p>
      </PrivacyBox>
    </PrivacySubsection>

    <PrivacySubsection title="4.2 Richiesta Eliminazione Dati sui Server">
      <p>
        Per richiedere l'eliminazione dei dati conservati sui nostri server (modulo di
        contatto, log di navigazione), compila il form di richiesta in fondo a questa
        pagina oppure invia un'email a
        <a href="mailto:info@appscontrini.it?subject=Richiesta%20cancellazione%20dati">info@appscontrini.it</a>
        con oggetto "Richiesta cancellazione dati".
      </p>
      <p>Nella richiesta, indica:</p>
      <ul>
        <li>L'indirizzo email utilizzato per contattarci (se applicabile)</li>
        <li>Il tipo di dati che desideri eliminare</li>
        <li>Eventuali riferimenti alla richiesta originale (data, oggetto del messaggio)</li>
      </ul>
    </PrivacySubsection>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'
import PrivacySubsection from '@/components/privacy/PrivacySubsection.vue'
import PrivacyBox from '@/components/privacy/PrivacyBox.vue'

export default {
  name: 'DeletionMethodsSection',
  components: {
    PrivacySection,
    PrivacySubsection,
    PrivacyBox
  }
}
</script>

<style scoped>
ol {
  font-size: 1.1rem;
  line-height: 1.8;
  padding-left: 2rem;
  margin-bottom: 1rem;
}

ol li {
  margin-bottom: 0.5rem;
  color: #555;
}

@media (max-width: 768px) {
  ol {
    font-size: 1rem;
  }
}
</style>
